export default __webpack_public_path__ + "static/careers-benefits-block1-icon12.url-68805eda5c3da202537c1ad1f6bce540.svg";